import { TextPage } from '../../../../components/TextPage/TextPage';
import { ModalComponent } from "../../../../components/Modal/ModalComponent/ModalComponent";
import dayjs from 'dayjs';
import './ModalListStrategy.scss'

// Заголовки таблицы
const header_list = [
    "Название",
    "Магазин",
    "Стратегия",
    "Статус",
    "Дата создания",
    "Дата редактирования"
]

const ModalListStrategy = ({
    search,
    setIsModal,
    data,
    setData,
    onAction
}) => {

    return (
        <ModalComponent
            title={<>Товар <span style={{ color: '#1890FF' }}>"{search}"</span> в стратегиях</>}
            onClose={(e) => {
                setData(null)
                setIsModal(false)
            }}
            style={{ height: 'autto' }}
            isNoData={!data?.length}
            child={<div className='modal-list-strategy'>
                {
                    data?.length ?
                        <div className='modal-list-strategy__content'>
                            <div className={`modal-list-strategy__table`}>
                                <div className={`modal-list-strategy__table-headers`}>
                                    {header_list?.map((point) => {
                                        return <div
                                            className={`modal-list-strategy__table-headers-item`}
                                            key={point}
                                        >
                                            <TextPage
                                                text={point}
                                                style={{
                                                    fontWeight: 700
                                                }}
                                            />
                                        </div>
                                    })}
                                </div>

                                {data?.map(({ id, name, api_id, strategy, status, created_at, updated_at }) => {
                                    const array_item = [name, api_id?.label || '', strategy?.name, status, created_at, updated_at]

                                    return <div
                                        className={`modal-list-strategy__table-row`}
                                        key={id}
                                        onClick={(e) => {
                                            onAction(id)
                                            setIsModal(false)
                                        }}
                                    >
                                        {array_item.map((item, ind) => {
                                            return <div key={item + ind} className={`modal-list-strategy__table-row-item`}>
                                                <TextPage
                                                    text={((ind === 4 || ind === 5) ? dayjs(item).format('DD.MM.YY HH:mm') : item) || 'Не назначено'}
                                                    style={{
                                                        color: item ? '' : '#888888'
                                                    }}
                                                />
                                            </div>
                                        })}
                                    </div>
                                })}
                            </div>
                        </div>
                        :
                        null
                }
            </div>}
        />
    )
}

export { ModalListStrategy }